function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.088 17.357c.325-.005.626.198.79.531.163.334.163.747 0 1.08-.164.334-.465.537-.79.532H3.912c-.325.005-.626-.198-.79-.531a1.254 1.254 0 010-1.08c.164-.334.465-.537.79-.532zm0-6.428c.325-.006.626.197.79.53.163.335.163.747 0 1.081-.164.334-.465.537-.79.531H3.912c-.325.006-.626-.197-.79-.53a1.256 1.256 0 010-1.081c.164-.334.465-.537.79-.531zm0-6.429c.325-.005.626.198.79.531.163.334.163.747 0 1.08-.164.334-.465.537-.79.532H3.912c-.325.005-.626-.198-.79-.531a1.254 1.254 0 010-1.08c.164-.334.465-.537.79-.532z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgMenuinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgMenuinline;